// extracted by mini-css-extract-plugin
export default {"experiencesSection":"experiences_experiencesSection__YKkf7","title":"experiences_title__N7Gsn","subtitle":"experiences_subtitle__Qom6t"};